import { CircleNotchIcon as PhosphorCircleNotchIcon } from "@phosphor-icons/react/dist/ssr/CircleNotch";

import { createAppIcon } from "@/components/createAppIcon";

export const SpinnerIcon = /* @__PURE__ */ createAppIcon(PhosphorCircleNotchIcon);
